import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { benefits } from '../data/mock';
import { Heart, Star, Sparkles, Trophy, Users, Music } from 'lucide-react';

const iconMap = {
  heart: Heart,
  star: Star,
  sparkles: Sparkles,
  trophy: Trophy,
  users: Users,
  music: Music,
};

const BenefitsSection = () => {
  const { t } = useLanguage();

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block text-[#8B1C1C] font-semibold text-sm uppercase tracking-wider mb-4">
            {t('Why Choose Us', 'Mengapa Memilih Kami')}
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-[#1e1919] mb-6">
            {t(
              'Benefits of Ballet for Children',
              'Manfaat Balet untuk Anak'
            )}
          </h2>
          <p className="text-[#736c64] text-lg">
            {t(
              'Ballet training provides numerous physical, mental, and social benefits for young children.',
              'Pelatihan balet memberikan banyak manfaat fisik, mental, dan sosial untuk anak-anak.'
            )}
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => {
            const Icon = iconMap[benefit.icon];
            return (
              <div
                key={index}
                className="group p-8 rounded-2xl bg-[#f7f5f2] hover:bg-[#8B1C1C] transition-all duration-300 cursor-default"
              >
                <div className="w-14 h-14 bg-white rounded-xl flex items-center justify-center mb-6 group-hover:bg-white/10 transition-colors">
                  <Icon className="w-7 h-7 text-[#8B1C1C] group-hover:text-white transition-colors" />
                </div>
                <h3 className="text-xl font-bold text-[#1e1919] group-hover:text-white mb-3 transition-colors">
                  {t(benefit.titleEn, benefit.titleId)}
                </h3>
                <p className="text-[#736c64] group-hover:text-white/80 transition-colors">
                  {t(benefit.descriptionEn, benefit.descriptionId)}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
